import React from 'react';
import PricingPage from './PricingPage';

/** Public pricing is always available (list prices from the catalog). */
const PricingRouteGate: React.FC = () => <PricingPage />;

export default PricingRouteGate;
